import { cloneElement, createElement } from '@wordpress/element';
import {
  Close,
  DownChevron,
  Hamburger,
  Instagram,
  LeftChevron,
  LinkedIn,
  RightChevron,
  X,
  YouTube,
} from './Icons';

export const ICONS_TYPES = [
  'close',
  'downChevron',
  'leftChevron',
  'rightChevron',
  'hamburger',
  'linkedin',
  'instagram',
  'x',
  'youtube',
] as const;
export type IconComponentsType = (typeof ICONS_TYPES)[number];

interface IconComponentProps extends React.SVGProps<SVGSVGElement> {
  type: IconComponentsType;
}

const iconComponents = {
  close: <Close />,
  downChevron: <DownChevron />,
  leftChevron: <LeftChevron />,
  rightChevron: <RightChevron />,
  hamburger: <Hamburger />,
  linkedin: <LinkedIn />,
  instagram: <Instagram />,
  x: <X />,
  youtube: <YouTube />,
};

export const Icon = ({ type, className, ...rest }: IconComponentProps) =>
  cloneElement(iconComponents[type], {
    className,
    ...rest,
  });
